// extracted by mini-css-extract-plugin
module.exports = {"host":"AppSidebar_host__JgYNg","logo":"AppSidebar_logo__2_r8z","card":"AppSidebar_card__3xO4V"};